import { ReactNode } from "react";

export const PatientStepsHint = ({children}: {children: ReactNode}) => (
  <span className="patient-step__select"> { children } </span>
);